var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoAgenda(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.1644 47.7693V14.719L44.6442 1H10.2291C9.5531 1 9 1.56123 9 2.24718V62.1119C9 62.7979 9.5531 63.3591 10.2291 63.3591H42.8006",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1644 47.7693V14.719L44.6442 1H10.2291C9.5531 1 9 1.56123 9 2.24718V62.1119C9 62.7979 9.5531 63.3591 10.2291 63.3591H42.8006",
    stroke: "#64727A",
    strokeWidth: 1.24755,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8734 14.719H58.1645L44.6443 1V13.4718C44.6443 14.1578 45.1974 14.719 45.8734 14.719Z",
    fill: "#A5B4BC",
    stroke: "#64727A",
    strokeWidth: 1.24755,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2183 35.9209H49.5606",
    stroke: "#64727A",
    strokeWidth: 1.24755,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6038 24.6963H48.9461",
    stroke: "#02080E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6038 30.3086H48.9461",
    stroke: "#64727A",
    strokeWidth: 1.24755,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2183 41.5332H49.5606",
    stroke: "#64727A",
    strokeWidth: 1.24755,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2183 47.1455H29.8948",
    stroke: "#64727A",
    strokeWidth: 1.24755,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9176_63898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 40C61.2843 40 68 46.7157 68 55C68 63.2843 61.2843 70 53 70C44.7157 70 38 63.2843 38 55C38 46.7157 44.7157 40 53 40ZM52.925 45.5688L52.7063 45.5814C51.7738 45.6897 51.05 46.4822 51.05 47.4438L51.0481 53.1231L45.3688 53.125L45.1501 53.1376C44.2176 53.2459 43.4938 54.0384 43.4938 55L43.5064 55.2187C43.6147 56.1512 44.4072 56.875 45.3688 56.875L51.0481 56.8731L51.05 62.5562L51.0626 62.7749C51.1709 63.7074 51.9634 64.4312 52.925 64.4312L53.1437 64.4186C54.0762 64.3103 54.8 63.5178 54.8 62.5562L54.7981 56.8731L60.4812 56.875L60.6999 56.8624C61.6324 56.7541 62.3562 55.9616 62.3562 55L62.3436 54.7813C62.2353 53.8488 61.4428 53.125 60.4812 53.125L54.7981 53.1231L54.8 47.4438L54.7874 47.2251C54.6791 46.2926 53.8866 45.5688 52.925 45.5688Z",
    fill: "#E04B9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9176_63898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(38 40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAgenda);
export default __webpack_public_path__ + "static/media/no_agenda.d06b98f6a19ab8dd1329bf2458df8dbe.svg";
export { ForwardRef as ReactComponent };